import * as MutationTypes from './mutationTypes';

export const addNotification = ({ commit }, notification) => commit(MutationTypes.ADD_NOTIFICATION, notification);
export const removeNotification = ({ commit }) => commit(MutationTypes.REMOVE_NOTIFICATION);
export const dismissNotifications = ({ commit }) => commit(MutationTypes.DISMISS_NOTIFICATIONS);
